'use client';

import {createProvidedStore} from '@utils/createProvidedStore';
import createZustandStore from '@utils/createZustandStore';

interface IDrawerStore {
    isOpen: boolean;
    toggle: (isOpen?: boolean) => void;
}

const createDrawerStore = (initialState?: Partial<IDrawerStore>) =>
    createZustandStore<IDrawerStore>(set => ({
        isOpen: false,
        ...initialState,

        toggle: isOpen =>
            set(state => {
                state.isOpen = isOpen !== undefined ? isOpen : !state.isOpen;
            }),
    }));

const store = createProvidedStore(createDrawerStore);
export const useDrawer = store.useStore;
export const withDrawer = store.withStoreProvider;
